(() => {
  'use strict';

  let host = null;
  let shadow = null;
  let dialog = null;
  let frame = 0;
  let listeners = null;

  const shadowObserver = new MutationObserver((records) => {
    if (!dialog?.isConnected || records.some(({ target }) => target === dialog || target.contains(dialog))) {
      schedule();
    }
  });

  const hostObserver = new MutationObserver(() => {
    if (!shadow || host !== document.getElementById('ads-agent-host') || !host.isConnected) schedule();
  });

  function sync() {
    frame = 0;
    const nextHost = document.getElementById('ads-agent-host');
    const nextShadow = nextHost?.shadowRoot || null;

    if (nextShadow !== shadow) {
      shadowObserver.disconnect();
      host = nextHost;
      shadow = nextShadow;
      dialog = null;
      if (shadow) {
        shadowObserver.observe(shadow, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['role', 'hidden', 'aria-hidden', 'open', 'class', 'style'],
        });
      }
    }

    dialog = [...(shadow?.querySelectorAll('[role="dialog"], dialog[open]') || [])].find((element) => {
      if (element.closest('[hidden], [aria-hidden="true"]')) return false;
      const rect = element.getBoundingClientRect();
      const style = getComputedStyle(element);
      return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
    }) || null;

    document.body.classList.toggle('im-assistant-open', Boolean(dialog));
  }

  function schedule() {
    if (listeners && !frame) frame = requestAnimationFrame(sync);
  }

  function onInteraction(event) {
    if (!shadow || event.composedPath().includes(host)) schedule();
  }

  function start() {
    if (listeners || !document.body) return;
    listeners = new AbortController();
    const options = { capture: true, passive: true, signal: listeners.signal };
    document.addEventListener('pointerdown', onInteraction, options);
    document.addEventListener('focusin', onInteraction, options);
    window.addEventListener('resize', schedule, { passive: true, signal: listeners.signal });
    hostObserver.observe(document.body, { childList: true, subtree: true });
    sync();
  }

  function stop() {
    listeners?.abort();
    listeners = null;
    hostObserver.disconnect();
    shadowObserver.disconnect();
    cancelAnimationFrame(frame);
    frame = 0;
    host = null;
    shadow = null;
    dialog = null;
    document.body?.classList.remove('im-assistant-open');
  }

  window.addEventListener('pagehide', stop);
  window.addEventListener('pageshow', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
